import { useHomeController } from "./Home.controller";
import { HomePresentation } from "./Home.pres";

export const HomeConnector = () => {
  const props = useHomeController();

  return <HomePresentation {...props} />;
};
